import * as React from 'react';
import { SVGProps } from 'react';

const IconBitSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 4H5v1.5H3.5v3.75l-1.5.773a2.261 2.261 0 0 0 2.261 2.26h.347L5 11.5h1.5l.392.784h2.216L9.5 11.5H11l.392.784h.347A2.261 2.261 0 0 0 14 10.023l-1.5-.773V5.5H11V4Z" />
  </svg>
);
export default IconBitSizeS;
